import FieldStateEnum from '@src/utils/enums/fieldStateEnum';

const resolveMin = (min, val) => (min === null ? val : Math.max(min, val));
const resolveMax = (max, val) => (max === null ? val : Math.min(max, val));

const stringIsDecimal = (str) => str.indexOf('.') > -1;

const stringEndInZero = (str) => str[str.length - 1] === '0';

export default {
  data: () => ({
    internalValue: null,
  }),
  created() {
    if (this.nullable) return;
    this.internalValue = 0;
  },
  mounted() {
    this.setNumberValue();
    this.setMaxMinValue();
  },
  methods: {
    handleBlur(e) {
      const inputVal = e.target?.value ?? e.value;
      if (this.nullable && inputVal === '') return;
      this.setNumber(inputVal, e);
    },
    resolveMaxMin(number) {
      let val = number;
      val = resolveMin(this.min, val);
      val = resolveMax(this.max, val);
      return val;
    },
    resolveNumber(stringNumber) {
      let val = Number(stringNumber);
      val = this.resolveMaxMin(val);
      return val;
    },
    setNumber(inputVal, e) {
      let val;
      if (inputVal.length === 0) {
        val = inputVal;
      } else if (this.numberType !== 'wholeNumber') {
        val = this.resolveNumber(inputVal);
      } else {
        val = Math.trunc(inputVal);
      }
      if (this[this.fieldKey].value === val
        || (this.internalValue
          && (stringIsDecimal(this.internalValue.toString())
          && inputVal.length !== this.internalValue.toString().length
          ))) {
        if (e && e.target) {
          const { target } = e;
          target.value = '';
          target.value = val;
        }
      }
      this[this.fieldKey].value = val;

      this.$emit('update:value', val);
    },
    inputChanged(e) {
      // To have formattedValue means a Primevue's InputNumber, we don't need to manipulate it.
      if (Object.hasOwn(e, 'formattedValue')) {
        this.$emit('update:value', e.value);
        return;
      }
      let inputVal = e.target.value;

      if (this.numberType === 'decimal') {
        // Handle the use of dot for decimals
        if (e.target.valueAsNumber === this.internalValue
          && (e.data === '.'
            || ['deleteContentForward', 'deleteContentBackward'].includes(e.inputType)
          )) return;
        // allow users to input blank numbers and unfinished decimals ending in 0
        if (stringIsDecimal(inputVal)
          && stringEndInZero(inputVal)
          && e.target.valueAsNumber === this.internalValue) return;
      } else {
        // Remove any dots if is not a decimal.
        inputVal = inputVal.replace('.', '');
      }
      this.setFieldState(FieldStateEnum.input);
      if (inputVal.length === 0 && !this.nullable) return;
      this.setNumber(inputVal, e);
    },
    setNumberValue() {
      let val = this.value || this.internalValue;
      val = this.resolveMaxMin(val);
      this.internalValue = val;
      this[this.fieldKey].value = this[this.fieldKey].value || this.internalValue;
      // since we are possibly changing the value based on max / min, we need to sync it immediately
      this.$emit('update:value', this[this.fieldKey].value);
    },
    setMaxMinValue() {
      this[this.fieldKey].max = this[this.fieldKey].max || this.max;
      this[this.fieldKey].min = this[this.fieldKey].min || this.min;
    },
  },
};
